import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-navigation-top',
  templateUrl: './navigation-top.component.html',
  styleUrls: ['./navigation-top.component.css']
})
export class NavigationTopComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
